// extracted by mini-css-extract-plugin
module.exports = {"selectControl":"Select_selectControl__1QGL0","label":"Select_label__1UI3w"};